import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HTTP interceptor that adds the mobile access token to Angular HttpClient requests
 * when the app is running inside a mobile WebView (mobile_access_token in localStorage).
 * This covers services like CountryService that use Angular HttpClient instead of Axios.
 */
@Injectable()
export class MobileAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const mobileToken = localStorage.getItem('mobile_access_token');
    if (mobileToken && !req.headers.has('Authorization')) {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${mobileToken}` }
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
